module.exports = __webpack_public_path__ + "img/1-to-al.825b7da6.png";